// extracted by mini-css-extract-plugin
export default {"Stats":"Stats_Stats__WOBZU","heading":"Stats_heading__Wcja-"};